import { __extends } from "tslib";
import { ListDropdownAwareFoundation } from './list-dropdown-aware-foundation';
var CascadingListDropdownAwareFoundation = /** @class */ (function (_super) {
    __extends(CascadingListDropdownAwareFoundation, _super);
    function CascadingListDropdownAwareFoundation(_config) {
        var _this = _super.call(this) || this;
        _this._config = _config;
        _this._open = false;
        _this._options = [];
        _this._childOpen = false;
        _this._popupHasMouse = false; // Used to determine if the popup element is under the users mouse
        _this._targetMouseEnterListener = function (evt) { return _this._onTargetMouseEnter(evt); };
        _this._targetMouseLeaveListener = function (evt) { return _this._onTargetMouseLeave(evt); };
        _this._childPopupMouseEnterListener = function () { return _this._onChildPopupMouseEnter(); };
        _this._childPopupMouseLeaveListener = function () { return _this._onChildPopupMouseLeave(); };
        _this._documentMouseMoveListener = function (evt) { return _this._mouseCoords = { x: evt.pageX, y: evt.pageY }; };
        return _this;
    }
    CascadingListDropdownAwareFoundation.prototype._onChildPopupMouseEnter = function () {
        this._popupHasMouse = true;
    };
    CascadingListDropdownAwareFoundation.prototype._onChildPopupMouseLeave = function () {
        var _this = this;
        this._popupHasMouse = false;
        setTimeout(function () {
            var mouseElement = document.elementFromPoint(_this._mouseCoords.x, _this._mouseCoords.y);
            if (!_this._popupHasMouse && !_this._childOpen && (!mouseElement || !_this._isOwnElement(mouseElement))) {
                _this._closeDropdown();
            }
        }, this._config.popupTimeout);
    };
    CascadingListDropdownAwareFoundation.prototype._onTargetMouseEnter = function (evt) {
        if (!this._options.length) {
            return;
        }
        this._openDropdown();
    };
    CascadingListDropdownAwareFoundation.prototype._onTargetMouseLeave = function (evt) {
        var _this = this;
        // We wrap this in a timeout to allow for the user to take an indirect path toward an open child menu. This
        // allows for the popup to stay open while the user is moving their mouse to it (makes the transition easier and more smooth)
        this._activeMouseLeaveTimeout = window.setTimeout(function () {
            // Ignore this if our open state has changed, or if we have a child popup open now
            if (!_this._open || _this._childOpen) {
                return;
            }
            if (_this._mouseCoords) {
                // We ignore this event if the mouse moved to an element within our own popup
                var mouseElement = document.elementFromPoint(_this._mouseCoords.x, _this._mouseCoords.y);
                if (mouseElement && _this._isOwnElement(mouseElement)) {
                    return;
                }
            }
            _this._closeDropdown();
        }, this._config.targetTimeout);
    };
    CascadingListDropdownAwareFoundation.prototype._clearMouseLeaveTimeout = function () {
        if (this._activeMouseLeaveTimeout !== undefined) {
            window.clearTimeout(this._activeMouseLeaveTimeout);
        }
    };
    return CascadingListDropdownAwareFoundation;
}(ListDropdownAwareFoundation));
export { CascadingListDropdownAwareFoundation };
